import type { SelfServiceAPI } from 'types';
import type { Options } from '../types';
import api from 'lib/axios/api';
import handleServiceError from '../utils/handleServiceError';

interface Params {
  bookingId: string;
  cancellationId: string;
}

const acceptCancellation = async (
  { bookingId, cancellationId }: Params,
  options: Options = {},
): Promise<SelfServiceAPI.AcceptCancellation.Response> => {
  try {
    const { data } = await api.post(`/bookings/${bookingId}/cancellations/${cancellationId}/accept`);
    return data;
  } catch (error) {
    handleServiceError(error, {
      operationName: `POST /bookings/${bookingId}/cancellations/${cancellationId}/accept`,
      skipUnauthenticatedRedirection: options.skipUnauthenticatedRedirection,
    });

    return new Promise(() => {});
  }
};

export default acceptCancellation;
